import { Number } from "../../common";

export const Price = (props) => {
  return <Number {...props} />;
};

